/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React from 'react';
import Props, {DispatchProps, StateProps} from './Props';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {
	flexServiceWorkerRegistrationSceneActivated,
	flexServiceWorkerRegistrationSceneDeactivated,
	flexServiceWorkerRegistrationScenePasswordInputChanged,
	flexServiceWorkerRegistrationScenePasswordSubmitted,
	flexServiceWorkerRegistrationScenePhoneNumberLookupInputChanged,
	flexServiceWorkerRegistrationScenePhoneNumberLookupSubmitted,
	flexServiceWorkerRegistrationScenePhoneVerificationCodeInputChanged,
	flexServiceWorkerRegistrationScenePhoneVerificationCodeSubmitted,
	flexServiceWorkerRegistrationSceneRequestResolvePersonalName,
	flexServiceWorkerRegistrationSceneRequestStopPhoneVerification
} from './actions';
import {RootState} from '../../reducers';
import {DisplayType} from './displayType';
import CenteredFormPanel from '../../components/CenteredFormPanel';
import PersonalName from './components/PersonalName';
import EnterPassword from '../../components/EnterPassword';
import PhoneNumber from './components/PhoneNumber';

class FlexServiceWorkerRegistration extends React.Component<Props> {

	componentDidMount() {
		const props: Readonly<Props> = this.props;

		props.onActivate();
	}

	componentWillUnmount() {
		const props: Readonly<Props> = this.props;

		props.onDeactivate();
	}

	render() {
		const props: Readonly<Props> = this.props;

		let display: JSX.Element | null;

		switch (props.index.displayType) {
			case DisplayType.DISPLAY_TYPE_PHONE_NUMBER:
				display =
					<PhoneNumber
						lookupValue={props.phoneNumber.lookupValue}
						violations={props.phoneNumber.violations}
						phoneNumberLookupResolved={props.phoneNumber.phoneNumberLookupResolved}
						phoneNumberLookupActive={props.phoneNumber.phoneNumberLookupActive}
						phoneNumberLookupSubmitDisabled={props.phoneNumber.phoneNumberLookupSubmitDisabled}
						onPhoneNumberLookupChange={props.phoneNumberDispatch.onPhoneNumberLookupChange}
						onPhoneNumberLookupSubmit={props.phoneNumberDispatch.onPhoneNumberLookupSubmit}
						verificationCode={props.phoneNumber.verificationCode}
						verificationCodeActive={props.phoneNumber.verificationCodeActive}
						verificationCodeSubmitDisabled={props.phoneNumber.verificationCodeSubmitDisabled}
						maximumDurationInSeconds={props.phoneNumber.maximumDurationInSeconds}
						onVerificationCodeChange={props.phoneNumberDispatch.onVerificationCodeChange}
						onVerificationCodeSubmit={props.phoneNumberDispatch.onVerificationCodeSubmit}
						onVerificationStopRequested={props.phoneNumberDispatch.onVerificationStopRequested}/>;
				break;
			case DisplayType.DISPLAY_TYPE_PERSONAL_NAME:
				display =
					<PersonalName
						submitDisabled={props.personalName.submitDisabled}
						onResolvePersonalNameSubmit={props.personalNameDispatch.onResolvePersonalNameSubmit}/>;
				break;
			case DisplayType.DISPLAY_TYPE_ENTER_PASSWORD:
				display = <EnterPassword
					strength={props.enterPassword.strength}
					minimumStrength={props.enterPassword.minimumStrength}
					submitDisabled={props.enterPassword.submitDisabled}
					email={props.enterPassword.email}
					violations={props.enterPassword.violations.password}
					onPasswordChange={props.enterPasswordDispatch.onPasswordChange}
					onSubmitPassword={props.enterPasswordDispatch.onSubmitPassword}/>;
				break;
			case DisplayType.DISPLAY_TYPE_NONE:
			default:
				display = null;
				break;
		}

		return (
			<CenteredFormPanel title="Inloggen" message={props.index.message} messageType={props.index.messageType}>
				{display}
			</CenteredFormPanel>

		);
	}
}

const mapStateToProps = (state: RootState): StateProps => ({
	enterPassword: state.flexServiceWorkerRegistration.enterPassword,
	index: state.flexServiceWorkerRegistration.index,
	personalName: state.flexServiceWorkerRegistration.personalName,
	phoneNumber: state.flexServiceWorkerRegistration.phoneNumber
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
	enterPasswordDispatch: {
		onPasswordChange: (password) => dispatch(flexServiceWorkerRegistrationScenePasswordInputChanged({evaluationRequest: {password}})),
		onSubmitPassword: (password) => dispatch(flexServiceWorkerRegistrationScenePasswordSubmitted({command: {password}}))
	},
	onActivate: () => dispatch(flexServiceWorkerRegistrationSceneActivated()),
	onDeactivate: () => dispatch(flexServiceWorkerRegistrationSceneDeactivated()),
	personalNameDispatch: {
		onResolvePersonalNameSubmit: () => dispatch(flexServiceWorkerRegistrationSceneRequestResolvePersonalName())
	},
	phoneNumberDispatch: {
		onPhoneNumberLookupChange: (country, phoneNumber) =>
			dispatch(flexServiceWorkerRegistrationScenePhoneNumberLookupInputChanged({country, phoneNumber})),
		onPhoneNumberLookupSubmit: (phoneNumberLookup) =>
			dispatch(flexServiceWorkerRegistrationScenePhoneNumberLookupSubmitted({command: {phoneNumberLookup}})),
		onVerificationCodeChange: (verificationCode) =>
			dispatch(flexServiceWorkerRegistrationScenePhoneVerificationCodeInputChanged({verificationCode})),
		onVerificationCodeSubmit: (verificationCode) =>
			dispatch(flexServiceWorkerRegistrationScenePhoneVerificationCodeSubmitted({command: {verificationCode}})),
		onVerificationStopRequested: () => dispatch(flexServiceWorkerRegistrationSceneRequestStopPhoneVerification())
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(FlexServiceWorkerRegistration);
